import { lazy, Suspense } from 'react';
import { Navigate, type RouteObject } from 'react-router-dom';
import DevTestGate from './DevTestGate';

const buildDevTestRoutes = (): RouteObject[] => {
	const DevWaitingExperiencePreview = lazy(
		() =>
			import(
				'@/features/sat-connection/linking-flow/waiting-experience/DevWaitingExperiencePreview'
			),
	);
	const OnboardingV3Sandbox = lazy(
		() => import('@/features/onboarding-v3/dev/OnboardingV3Sandbox'),
	);
	const SessionRecordingCheck = lazy(
		() => import('@/shared/analytics/SessionRecordingCheck'),
	);
	const DeclarationsNewPreview = lazy(
		() => import('@/features/declarations-new/dev/DeclarationsNewPreview'),
	);
	const PlatformsDemo = lazy(() => import('@/features/platforms/dev/PlatformsDemo'));
	const SatIdDemo = lazy(() => import('@/features/sat-id/dev/SatIdDemo'));
	const SatIdSentDemo = lazy(() => import('@/features/sat-id/dev/SatIdSentDemo'));
	const PermissionsDiagnostics = lazy(
		() => import('@/features/dev-permissions/views/PermissionsDiagnostics'),
	);

	return [
		{
			id: 'dev-test',
			path: '/dev-test',
			element: <DevTestGate />,
			children: [
				{
					index: true,
					element: <Navigate to='linking-waiting' replace />,
				},
				{
					id: 'dev-test-linking-waiting',
					path: 'linking-waiting',
					element: (
						<Suspense fallback={null}>
							<DevWaitingExperiencePreview />
						</Suspense>
					),
				},
				{
					id: 'dev-test-onboarding-v3',
					path: 'onboarding-v3',
					element: (
						<Suspense fallback={null}>
							<OnboardingV3Sandbox />
						</Suspense>
					),
				},
				{
					id: 'dev-test-declaraciones',
					path: 'declaraciones',
					element: (
						<Suspense fallback={null}>
							<DeclarationsNewPreview />
						</Suspense>
					),
				},
				{
					id: 'dev-test-plataformas',
					path: 'plataformas',
					element: (
						<Suspense fallback={null}>
							<PlatformsDemo />
						</Suspense>
					),
				},
				{
					id: 'dev-test-sat-id-sent',
					path: 'sat-id/:tramite/enviado',
					element: (
						<Suspense fallback={null}>
							<SatIdSentDemo />
						</Suspense>
					),
				},
				{
					id: 'dev-test-sat-id',
					path: 'sat-id/:tramite?',
					element: (
						<Suspense fallback={null}>
							<SatIdDemo />
						</Suspense>
					),
				},
				{
					id: 'dev-test-permissions',
					path: 'permissions',
					element: (
						<Suspense fallback={null}>
							<PermissionsDiagnostics />
						</Suspense>
					),
				},
				{
					id: 'dev-test-session-recording',
					path: 'session-recording',
					element: (
						<Suspense fallback={null}>
							<SessionRecordingCheck />
						</Suspense>
					),
				},
			],
		},
	];
};

// Montadas SIEMPRE (también en prod): DevTestGate decide en runtime — build
// dev pasa libre; en prod exige sesión con correo @heru-app.com, así el
// equipo revisa el sandbox directo en producción sin levantar local. Los
// chunks son lazy: nadie que no visite /dev-test los descarga.
export const devTestRoutes: RouteObject[] = buildDevTestRoutes();
